export * from './LocationDetail';
